// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__E8SU-","logo":"Header_logo__JgOE6","select":"Header_select__tVdb9"};